<template lang="pug">
  .request-builder-scale
    .search
      input(type="text", :placeholder="'request-builder-search'|translate", v-model="search")
    .list
      drag.elem(:transfer-data="{ s }",v-for="s, idx in scales",v-if="!isActive(s) && searchFn(s)",:key="idx")
        span(@click="add(s)") {{s}}
    drop.selected(@drop="handleDrop")
      .placeholder(v-if="isEmpty") {{'request-builder-placeholder'|translate}}
      .elem(v-for="s, idx in scalesSelected",v-if="isActive(s)",:key="idx")
        span {{s}}
        i.fpui.fpui-remove(@click="remove(s)")
</template>

<script>
  import {uniq} from 'lodash'
  export default {
    props: ['dataset', 'value'],
    data () {
      return {
        search: ''
      }
    },
    methods: {
      add (scale) {
        this.$emit('input', {...this.value, fields: this.value.fields.concat(scale)})
      },
      handleDrop (data) {
        let value = Object.assign({}, this.value)
        value.fields.push(data.s)
        this.$emit('input', value)
      },
      searchFn (key) {
        if (!key && !key !== 0 && !this.search) return true
        return key.toLowerCase().indexOf(this.search.toLowerCase()) !== -1
      },
      isActive (key) {
        return this.value.fields.indexOf(key) !== -1
      },
      remove (key) {
        let value = Object.assign({}, this.value)
        value.fields.splice(value.fields.indexOf(key), 1)
        this.$emit('input', value)
      }
    },
    computed: {
      scales () { return uniq(this.dataset.scales.concat(this.dataset.data)).sort() },
      scalesSelected () { return this.value.fields || [] },
      isEmpty () {
        if (!this.value || !Array.isArray(this.value.fields)) return true
        return this.value.fields.length === 0
      }
    }
  }
</script>

<style lang="less">
.request-builder-scale {
  height: 100%;
  position: relative;
  .list {
    overflow-y: auto;
    max-height: calc(~"100% - 80px");
  }
}
</style>
